module.exports = __webpack_public_path__ + "media/nicole10.f027c7e9.mp3";